var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.983,
    height: 15.266,
    viewBox: "0 0 14.983 15.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inbox",
    transform: "translate(-6 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M20.932,21.553l-2.827-6.219A.565.565,0,0,0,17.591,15H15.612a.565.565,0,0,0,0,1.131h1.614l2.312,5.089H15.894a.565.565,0,0,0-.565.565V23.2H11.371V21.785a.565.565,0,0,0-.565-.565H7.413l2.081-5.089h1.594a.565.565,0,0,0,0-1.131H9.11a.565.565,0,0,0-.523.351L6.042,21.57A.565.565,0,0,0,6,21.785v5.089a.565.565,0,0,0,.565.565H20.418a.565.565,0,0,0,.565-.565V21.785A.565.565,0,0,0,20.932,21.553Zm-13.8,4.755V22.35h3.11v1.413a.565.565,0,0,0,.565.565h5.089a.565.565,0,0,0,.565-.565V22.35h3.392v3.958Z",
    transform: "translate(0 -7.173)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M23.169,10.538a.565.565,0,0,0,0,.8l1.979,1.979a.565.565,0,0,0,.8,0l1.979-1.979a.566.566,0,1,0-.8-.8l-1.015,1.015V5.565a.565.565,0,1,0-1.131,0v5.988l-1.015-1.015A.565.565,0,0,0,23.169,10.538Z",
    transform: "translate(-12.197)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.664230e2215ede7f5a2c94b0b421e689.svg";
export { ForwardRef as ReactComponent };